import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VeeValidate, { Validator } from 'vee-validate'
import validateRu from 'vee-validate/dist/locale/ru'
import VTree from 'vue-tree-halower'
import axios from 'axios'
import vueMoment from 'vue-moment'

export default (Vue, ...params) => {
  params.filter(el => typeof el === 'object')
    .map(le => Vue.use(le))
  Vue.use(VueRouter)
  Vue.use(VeeValidate)
  Validator.localize('ru', validateRu)
  Vue.use(VueResource)
  Vue.use(VTree)
  Vue.use(vueMoment)
  axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `JWT ${token}`
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })
  Vue.http.interceptors.push((request, next) => {
    request.headers.set('Authorization', 'JWT ' + localStorage.getItem('token'))
    request.headers.set('Accept', 'application/json')
    next()
  })
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return axios
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/config/plugins.js